exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--answers__1mtNW{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.styles--answer__FKaNL{margin-bottom:20px}.styles--answer__FKaNL:last-child{margin-bottom:0}.styles--answerBlock__1WieW{word-break:break-word;margin-top:5px;display:grid}.styles--answerBlock__1WieW p{word-break:break-word;margin-bottom:0;white-space:pre-wrap}.styles--answerBlock__1WieW pre{word-break:break-word;overflow:auto;font:inherit;white-space:pre-wrap}.styles--answerTitle__2_7d9{margin-bottom:5px;font-weight:600}.styles--answerTitleInline__QjY79{font-weight:600}.styles--question__uLodL{display:block}.styles--questionTitle__e3zdH{font-weight:600}\n", ""]);

// exports
exports.locals = {
	"answers": "styles--answers__1mtNW",
	"answer": "styles--answer__FKaNL",
	"answerBlock": "styles--answerBlock__1WieW",
	"answerTitle": "styles--answerTitle__2_7d9",
	"answerTitleInline": "styles--answerTitleInline__QjY79",
	"question": "styles--question__uLodL",
	"questionTitle": "styles--questionTitle__e3zdH"
};